<template>
  <Row>
    <!-- 树形目录 -->
    <Col span="6">
      <Tree :data="treeData" @on-select-change="clickData"></Tree>
    </Col>
    <!-- 分类列表 -->
    <Col span="18">
      <div class="public-screen">
        <span>{{ currentName }}</span>
        <Button
          type="primary"
          icon="md-add"
          v-access="'classInfo.add'"
          @click="dpOpenFn()"
          >添加分类</Button
        >
      </div>
      <Table border stripe :loading="loading" :columns="columns" :data="tbList">
        <template slot-scope="{ row, index }" slot="index">
          <span v-if="false">{{ row }}</span>
          {{ index + 1 }}
        </template>
        <template slot="parent">
          {{ currentName }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'classInfo.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            v-access="'classInfo.edit'"
            @click="dpOpenFn(row, index)"
            >编辑</a
          >
          <a
            href="javascript:;"
            v-access="'classInfo.delete'"
            @click="removeFn(index, row)"
            >删除</a
          >
        </template>
      </Table>
    </Col>
    <!-- 单个分类 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增分类' : '编辑分类'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form ref="formValidate" :label-width="80">
        <FormItem>
          <span slot="label" class="public-require">名称</span>
          <Input v-model="queryForm.name" placeholder="请输入分类名称"></Input>
        </FormItem>
        <FormItem>
          <span ref="brick" slot="label" class="public-require">所属分类</span>
          <Input v-if="editing" :value="currentName" disabled></Input>
          <Treeselect
            v-else
            v-model="queryForm.pCode"
            :data="selectData"
            text-field-name="name"
            value-field-name="code"
            size="small"
            placeholder="全部分类"
          ></Treeselect>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import Treeselect from "vue-treeselect";
const columns = [
  {
    title: "序号",
    slot: "index",
  },
  {
    title: "分类名称",
    key: "name",
  },
  {
    title: "所属分类",
    slot: "parent",
  },
  {
    title: "分类级别",
    key: "level",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      treeData: [],
      selectData: [],
      columns,
      tbList: [],
      loading: false,
      currentName: "全部分类",
      currentCode: "",
      formModel: false,
      formTitle: "0",
      formModalLoading: true,
      queryForm: {
        name: "",
        pCode: "",
      },
      updateCode: "",
      editing: false,
    };
  },
  created() {
    this.getTree();
    this.getList();
  },
  watch: {
    // tree选择后收起选项
    "queryForm.pCode"(a, b) {
      this.$refs.brick.click();
    },
    deep: true,
  },
  methods: {
    getTree() {
      this.$api["categoryAll"]({}).then((res) => {
        if (res.code == "200") {
          let treeSt = {
            name: "全部分类",
            code: "",
            expand: false,
            parentCode: "-1",
          };
          let selectSt = {
            name: "全部分类",
            code: "",
            opened: false,
            parentCode: "-1",
          };
          let list = [];
          let list1 = [];
          if (res.data && res.data.length > 0) {
            list = [...res.data, treeSt];
            list1 = [...res.data, selectSt];
          }
          this.treeData = this.tools.arrayToTree(list);
          this.selectData = this.tools.arrayToTree(list1, 1);
        }
      });
    },
    getList() {
      let data = { parentCode: this.currentCode };
      this.loading = true;
      this.$api["categorySearch"](data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    clickData(arr, item) {
      this.currentName = item.name;
      this.currentCode = item.code;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 删除分类
    removeFn(i, d) {
      let that = this;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let data = { code: d.code };
          that.$api.categoryDelete(data).then((res) => {
            if (res.code == "200") {
              that.getTree();
              that.getList();
            }
          });
        },
      });
    },
    // 打开分类
    dpOpenFn(d) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      this.editing = d ? true : false;
      if (d) {
        this.updateCode = d.code;
        this.queryForm = {
          name: d.name,
          pCode: d.parentCode,
        };
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 确定分类
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      if (!this.queryForm.name) {
        this.$Message.error("请输入分类名称");
        return;
      }
      if (
        this.queryForm.pCode == "" ||
        this.queryForm.pCode == null ||
        this.queryForm.pCode == undefined
      ) {
        this.queryForm.pCode = "";
      }
      let data = {
        name: this.queryForm.name,
        parentCode: this.queryForm.pCode,
      };
      let http = "categoryAdd";
      if (this.formTitle == 1) {
        data.code = this.updateCode;
        http = "categoryUpdate";
      }
      this.$api[http](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("操作成功");
          this.cancelAction();
          this.getTree();
          this.getList();
        }
      });
    },
    cancelAction() {
      this.queryForm.name = "";
      this.queryForm.pCode = null;
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "categoryDisable" : "categoryEnable";
      this.$api[http]({ code: d.code }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/commodity/classInfo.vue